<template>
  <div>
    <b-card-text>
      対象のステータスが変化します。
    </b-card-text>
    <b-form-group id="status" label="効果"
      label-cols="3">
      <b-container>
        <b-row v-for="(k,j) in chunk4fixStatus" :key="'f'+j">
          <b-col cols="6" v-for="l in k" :key="'fs'+l">
            <b-input-group :prepend="l">
              <b-form-input type="number" v-model="innerValue.arguments[l]" 
                number />
            </b-input-group>
          </b-col>
        </b-row>
      </b-container>
    </b-form-group>
    <b-card title="異常状態">
      <b-form-group id="PowerRatio" label="Lv係数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.PowerRatio" 
          type="number" :min="0" :max="99" :step="0.1" number />
      </b-form-group>
    </b-card>
    <b-button variant="danger" size="sm"
      @click="$emit('removeCode')">
      <b-icon icon="x" />削除
    </b-button>
  </div>
</template>

<script>
import _ from 'lodash'
const fixStatus = ['STR','INT','VIT','MND','DEX','AGI']
const newCode = ()=>{
  return {
    target: { '@arg':'target' },
    buff: { '@arg':'buff' },
    added: { '@arg':'added' },

    STR:0, INT:0, VIT:0, MND:0, DEX:0, AGI:0,

    PowerRatio: 0.0,
  }    
}
export default {
  props: {
    value: Object,
    info: Object
  },
  computed: {
    chunk4fixStatus () { return _.chunk(fixStatus,2 ) },
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  watch: {
    'innerValue.arguments' () {
      this.$emit('input', this.innerValue)
    },
    value (v) {
      this.innerValue = v
    }
  },
  newCode
}
</script>

<style lang="scss" scoped>

</style>
